import { render } from "./UserOrders.vue?vue&type=template&id=38d0007e&scoped=true&ts=true"
import script from "./UserOrders.vue?vue&type=script&lang=ts"
export * from "./UserOrders.vue?vue&type=script&lang=ts"

import "./UserOrders.vue?vue&type=style&index=0&id=38d0007e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d0007e"]])

export default __exports__